import { useState } from 'react';
import styles from './custom-slider.module.css';

interface CustomSliderProps {
	min?: number;
	max?: number;
	value?: number;
	onChange?: (value: number) => void;
}

export const CustomSlider = ({
	min = 0,
	max = 20,
	value = 0,
	onChange,
}: CustomSliderProps) => {
	const [sliderValue, setSliderValue] = useState(value);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = Number(e.target.value);
		setSliderValue(newValue);
		if (onChange) onChange(newValue);
	};

	const percentage = ((sliderValue - min) / (max - min)) * 95;
	const handlePosition = `calc(${percentage}% + 6px)`;
	const stickHeight = 44;

	return (
		<div
			className={styles.slider}
			style={
				{
					'--progress': `${percentage}%`,
					'--primary': '#004060ff',
					'--primaryContainer': '#7f9fafff',
				} as React.CSSProperties
			}
		>
			<div
				className={styles.stickContainer}
				style={{
					left: `calc(${percentage}%)`,
					top: `calc(${stickHeight}px + 14px)`,
				}}
			>
				<div
					className={styles.stick}
					style={{
						position: 'absolute',
						bottom: 0,
						height: `${stickHeight}px`,
					}}
				/>
			</div>

			<div
				className={styles.customHandle}
				style={{ left: handlePosition }}
			>
				{sliderValue}
			</div>

			<input
				type="range"
				min={min}
				max={max}
				value={sliderValue}
				onChange={handleChange}
				className={styles.rangeInput}
			/>

			<div className={styles.endDot} />
		</div>
	);
};
